import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

const API_URL = 'https://social-auto-r8we.onrender.com/api/facebook';

export const addFacebookAccount = createAsyncThunk(
    'facebook/addAccount',
    async (cookies, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const { data } = await axios.post(`${API_URL}/accounts`, { cookies }, config);
            return data;
        } catch (error) {
            return rejectWithValue(error.response.data.message);
        }
    }
);

export const getFacebookAccounts = createAsyncThunk(
    'facebook/getAccounts',
    async (_, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const { data } = await axios.get(`${API_URL}/accounts`, config);
            return data;
        } catch (error) {
            return rejectWithValue(error.response.data.message);
        }
    }
);

export const scrapePost = createAsyncThunk(
    'facebook/scrapePost',
    async ({ accountId, postUrl }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const { data } = await axios.post(`${API_URL}/scrape`, { accountId, postUrl }, config);
            return data;
        } catch (error) {
            return rejectWithValue(error.response.data.message);
        }
    }
);

export const likePost = createAsyncThunk(
    'facebook/likePost',
    async ({ accountId, postUrl }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const { data } = await axios.post(`${API_URL}/like`, { accountId, postUrl }, config);
            return data;
        } catch (error) {
            return rejectWithValue(error.response.data.message);
        }
    }
);

export const commentOnPost = createAsyncThunk(
    'facebook/commentOnPost',
    async ({ accountId, postUrl, commentText }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const { data } = await axios.post(`${API_URL}/comment`, { accountId, postUrl, commentText }, config);
            return data;
        } catch (error) {
            return rejectWithValue(error.response.data.message);
        }
    }
);

export const sendMessengerMessage = createAsyncThunk(
    'facebook/sendMessengerMessage',
    async ({ accountId, recipientId, message }, { getState, rejectWithValue }) => {
        try {
            const token = getState().auth.token;
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const { data } = await axios.post(`${API_URL}/messenger`, { accountId, recipientId, message }, config);
            return data;
        } catch (error) {
            return rejectWithValue(error.response.data.message);
        }
    }
);

const facebookSlice = createSlice({
    name: 'facebook',
    initialState: {
        accounts: [],
        scrapeData: null,
        loading: false,
        error: null,
    },
    reducers: {
        clearError: (state) => {
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(addFacebookAccount.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(addFacebookAccount.fulfilled, (state, action) => {
                state.loading = false;
                state.accounts.push(action.payload);
            })
            .addCase(addFacebookAccount.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(getFacebookAccounts.fulfilled, (state, action) => {
                state.accounts = action.payload;
            })
            .addCase(scrapePost.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(scrapePost.fulfilled, (state, action) => {
                state.loading = false;
                state.scrapeData = action.payload;
            })
            .addCase(scrapePost.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(likePost.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(likePost.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(likePost.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(commentOnPost.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(commentOnPost.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(commentOnPost.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(sendMessengerMessage.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(sendMessengerMessage.fulfilled, (state) => {
                state.loading = false;
            })
            .addCase(sendMessengerMessage.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { clearError } = facebookSlice.actions;
export default facebookSlice.reducer;
